const DeletionType = {
  REQUEST: "Request",
  DELETION: "Deletion",
};

export default DeletionType;
